import { NgModule } from '@angular/core';

import { InputBaseComponent } from './input-base.component';
import { FormsModule } from '@angular/forms';

/**
 * Angular module providing the base input component for form controls.
 *
 * @remarks
 * This module exports {@link InputBaseComponent}, which serves as the foundation for all
 * input components in the design system. It includes the necessary {@link FormsModule} configuration
 * to handle the legacy setDisabledState behavior and provides the base component that other
 * input modules can extend from.
 *
 * @example
 *
 * ```typescript
 * import { InputBaseModule } from '@backbase/ui-ang/base-classes';
 *
 * @NgModule({
 *   imports: [InputBaseModule, ProductItemBaseModule],
 *   exports: [InputBaseModule, ProductItemBaseModule],
 * })
 * export class BaseClassesModule {}
 * ```
 */
@NgModule({
  imports: [
    // temporary fix to resolve https://github.com/angular/angular/issues/48350
    FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
  ],
  declarations: [InputBaseComponent],
  exports: [InputBaseComponent],
})
export class InputBaseModule {}
